import { AppBar, Link, Toolbar } from '@material-ui/core'
import CssBaseline from '@material-ui/core/CssBaseline'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import ImageLogo from '../commons/asset/Template_FullColor.png'
import AdminOption from '../commons/components/AdminOption'
import { CATEGORIES_ROUTE, CATEGORY_MANAGEMENT_ROUTE } from '../const/route'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    paddingLeft: 'unset',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 1,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#feffff',
    color: 'black',
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    background: '#f4f5f6',
  },
  tableContainer: {
    width: '100%',
    height: '100%',
  },
})

function* skipAndTakeGenerator(arr, n) {
  let start = 0
  while (start + n < arr.length) {
    const end = start + n
    const part = arr.slice(start, end)
    start = end
    yield part
  }
  yield arr.slice(start)
}

const PublisherLayoutComponents = ({ classes, children, isPublisher }) => {
  return (
    <div className={classes.root}>
      <CssBaseline />

      <AppBar position="absolute" className={classNames(classes.appBar)}>
        <Toolbar className={classes.toolbar}>
          <img
            alt="logo"
            src={ImageLogo}
            style={{ width: '225px', marginRight: '20px' }}
          />
          <nav>
            <Link
              style={{ padding: '15px' }}
              variant="button"
              href={CATEGORIES_ROUTE}
              sx={{ my: 1, mx: 1.5 }}
            >
              Templates
            </Link>
            <Link
              style={{ padding: '15px' }}
              variant="button"
              href={CATEGORY_MANAGEMENT_ROUTE}
              sx={{ my: 1, mx: 1.5 }}
            >
              Category Management
            </Link>
          </nav>
          <AdminOption />
        </Toolbar>
      </AppBar>

      <main className={classes.content}>
        <div className={classes.tableContainer}>
          {React.Children.map(children, child => {
            return React.cloneElement(child, { isPublisher }, null)
          })}
        </div>
      </main>
    </div>
  )
}

PublisherLayoutComponents.propTypes = {
  classes: PropTypes.object,
}

const PublisherLayout = withStyles(styles)(PublisherLayoutComponents)
export default PublisherLayout
